<template>
  <v-dialog v-model="dialog" width="500" light persistent>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Send Test Email
      </v-card-title>

      <v-card-text class="pt-4 pa-4">
        Voulez-vous envoyer un e-mail de test
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn color="success" small :loading="loading" @click="sendEmail()">Send</v-btn>
        <v-btn color="info" small :disabled="loading" @click="closePopup">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';

// eslint-disable-next-line no-undef
const props = defineProps({
  uuid: {
    type: String,
    default: null
  },
  showErrorMessage: { type: Function },
  showSuccessMessage: { type: Function }
});

const store = useStore();

const currentUser = computed(() => store.state.currentUser);

const dialog = ref(false);

const loading = ref(false);

const open = () => {
  dialog.value = true;
};

const closePopup = () => {
  dialog.value = false;
};

const emailRecipients = ref([]);

const { mutate: sendEmailMutation, onDone, onError } = useMutation(gql(`
      mutation alphaSendEmailToRecipient($uuid: ID, $recipients: [String]!) {
        alphaSendEmailToRecipient(uuid: $uuid, recipients: $recipients) {
          success
          message
          data
        }
      }
    `), () => ({ variables: { uuid: props.uuid, recipients: emailRecipients.value } }));

onDone(result => {
  if (!result.data.alphaSendEmailToRecipient.success) {
    props.showErrorMessage(result.data.alphaSendEmailToRecipient.message);
    return;
  }

  props.showSuccessMessage('E-mail envoyé avec succès');
});

onError(error => {
  console.log('[ERROR] Sending Email ->', error);

  props.showErrorMessage("J'ai corrigé une erreur lors de l'envoi d'un e-mail");
});

const sendEmail = () => {
  emailRecipients.value = [];
  if (currentUser.value && currentUser.value.email) emailRecipients.value.push(currentUser.value.email);

  loading.value = true;
  sendEmailMutation();
  loading.value = false;

  closePopup();
};

// eslint-disable-next-line no-undef
defineExpose({ open });

</script>
